module.exports = __webpack_public_path__ + "static/img/19.5308b39.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/3/zh/19.png
// module id = PSa0
// module chunks = 0